export default __webpack_public_path__ + "static/media/notFound.ddc801c9.svg";